module.exports = __webpack_public_path__ + "img/36036-022.d88fbafb.jpg";